var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mail-integration-detail" } }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "toolbar" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "IconButton",
              {
                attrs: {
                  "on-click": function () {
                    return _vm.$router.push("/integrations/mail")
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" chevron_left "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "icon-container" }, [
              _c("img", { attrs: { src: _vm.logoUrl } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "name" }, [
              _vm._v(
                "Mail Detail: " +
                  _vm._s(_vm.selectedMail ? _vm.selectedMail.mail : "")
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "danger" },
                on: {
                  click: function ($event) {
                    return _vm.deleteMailAddress()
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s("Sil") +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "channel-content" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("Menus", {
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _vm.currentTab === _vm.menuTypes.INTEGRATION.id
            ? _c("div", [_c("Integration")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.menuTypes.SENDER.id
            ? _c("div", [_c("SenderMailAddress")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.menuTypes.SIGNATURE.id
            ? _c("div", [_c("Signature")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.menuTypes.INBOX.id
            ? _c(
                "div",
                [_c("Mails", { attrs: { selectedMail: _vm.selectedMail } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.menuTypes.MEDIA.id
            ? _c("div", [_c("Medias")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.menuTypes.VISIBILITY.id
            ? _c("div", [_c("VisibilityChanger")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.menuTypes.CONTACTS.id
            ? _c("div", [_c("MailVisitors")], 1)
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }